import { ChildRef } from "../../../../../lib/web/components/child-ref";
import { ChildrenRef } from "../../../../../lib/web/components/children-ref";
import { ClickListener } from "../../../../../lib/web/components/click-listener";
import { Component } from "../../../../../lib/web/components/component";
import { ComponentBase } from "../../../../../lib/web/components/component-base";
import { DataEventService } from "../../../services/data-event.service";
import { DiscoveryAssistantStep } from "../../pages/discovery-assistant/discovery-assistant.component";

@Component({
    selector: '.o-discovery-assistant-questions'
})
export class DiscoveryAssistantQuestionsComponent extends ComponentBase<HTMLElement> implements DiscoveryAssistantStep {
   
    @ChildrenRef(HTMLDivElement, '.o-discovery-assistant-questions__question')
    private _questions: HTMLDivElement[] = null;
    @ChildrenRef(HTMLButtonElement, '.o-discovery-assistant-questions__questionNumber')
    private _questionsNumber: HTMLButtonElement[] = null;
    @ChildRef('.o-discovery-assistant-questions__previous')
    private _previous: HTMLButtonElement = null;
    @ChildRef('.o-discovery-assistant-questions__next')
    private _next: HTMLButtonElement = null;

    private _assistant: any = null;
    
    public constructor(node: HTMLElement, private _dataEventService: DataEventService) {
        super(node);
    }

    @ClickListener('.o-discovery-assistant-questions__back')
    public onBackClick(): void {
        window.dispatchEvent(new CustomEvent('discovery-assistant-previous-step'));
        this.clear();
    }

    @ClickListener('.o-discovery-assistant-questions__next')
    public onNextClick(): void {
        const anwser: string = this._questions.map(question => Array.from(question.querySelectorAll('.o-discovery-assistant-questions__answer')).indexOf(question.querySelector('.o-discovery-assistant-questions__answer--active')) === 0 ? 'A' :'B')[this.current];
        this._dataEventService.onboardingNextQuestion(this._questions[this.current].dataset.id, anwser);
        if (this.current < this._questions.length - 1) {
            this.setCurrent(this.current + 1);
        }
        else {
            this._assistant.answers = this._questions.map(question => Array.from(question.querySelectorAll('.o-discovery-assistant-questions__answer')).indexOf(question.querySelector('.o-discovery-assistant-questions__answer--active')) === 0 ? 'A' :'B');            
            window.dispatchEvent(new CustomEvent('discovery-assistant-next-step'));
            this.clear();            
        }
    }

    @ClickListener('.o-discovery-assistant-questions__previous')
    public onPreviousClick(): void {
        if (this.current > 0) {
            this.setCurrent(this.current - 1);
        }
        else {
            window.dispatchEvent(new CustomEvent('discovery-assistant-previous-step'));
            this.clear();
        }
    }

    @ClickListener('.o-discovery-assistant-questions__answer')
    public onAnswerClick(e: MouseEvent): void {
        this.setAnswer(e.currentTarget as HTMLDivElement);
    }

    public onInit(): void {
        super.onInit();         
        this.setCurrent(0);
    }

    private clear(): void {        
        Array.from(this._node.querySelectorAll('.o-discovery-assistant-questions__answer')).forEach(a => a.classList.remove('o-discovery-assistant-questions__answer--active'));            
        this.setCurrent(0, true);
    }

    private setCurrent(value: number, isClear: boolean = false): void {
        this._questionsNumber.forEach((questionNumber, index) => {
            questionNumber.classList.remove('o-discovery-assistant-questions__questionNumber--active');
            if (index === value) {
                questionNumber.classList.add('o-discovery-assistant-questions__questionNumber--active');
            }
        });
        this._questions.forEach((question, index) => {
            question.classList.add('u-hidden');
            if (index === value) {
                question.classList.remove('u-hidden');
            }
        });
        this.setStatusNavigation();

        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this._assistant && !isClear) {
            this._dataEventService.onboardingQuestion(this._questions[this.current].dataset.id);
        }
    }

    private setAnswer(answer: HTMLDivElement): void {
        const anwsers: HTMLDivElement[] = Array.from(answer.closest('.o-discovery-assistant-questions__answers').querySelectorAll('.o-discovery-assistant-questions__answer'));
        anwsers.forEach((anwsers) => {
            anwsers.classList.remove('o-discovery-assistant-questions__answer--active');
            if (anwsers === answer) {
                anwsers.classList.add('o-discovery-assistant-questions__answer--active');
            }
        });
        this.setStatusNavigation();
    }
    
    private setStatusNavigation(): void {
        this._previous.disabled = this.current === 0;
        this._next.disabled = this._questions[this.current].querySelector('.o-discovery-assistant-questions__answer--active') == null;
    }

    public get current(): number {
        return this._questionsNumber.findIndex((questionNumber) => questionNumber.classList.contains('o-discovery-assistant-questions__questionNumber--active'));
    }

    public enter(assistant: any, interestClusters: any[], mode: string): void {        
        this._assistant = assistant;
        this._dataEventService.onboardingQuestion(this._questions[this.current].dataset.id);
    }

    public exit(): void {
    }
}